module.exports = __webpack_public_path__ + "img/characters120On.529d3a7e.svg";